<div class="dialog">
    <div class="dialog-header">
        <h2>{{ data.title || ('shared.dialog.alert.api.heading.400' | translate) }}</h2>
    </div>
    <div class="dialog-body">
        <p>
            {{ 'shared.dialog.alert.api.text' | translate }}
            <br>
            "<strong [innerHTML]="data.message | capitalize | newlines"></strong>"
        </p>

        <div class="buttons">
            <a class="button button-primary" (click)="onClose()">{{ 'shared.button.close' | translate }}</a>
        </div>
    </div>
</div>

